<script setup>
import { useRouter } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';

const router = useRouter();

const navigateToCreateAgent = () => {
  router.push({ name: 'agentis_create' });
};
</script>

<template>
  <Button
    label="Adicionar Agente"
    icon="i-lucide-plus"
    color="blue"
    class="fixed bottom-6 right-6 shadow-lg z-10 md:relative md:bottom-auto md:right-auto md:shadow-none"
    @click="navigateToCreateAgent"
  />
</template>